/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Location View - TabPanel
 */
import React from 'react';
import PropTypes from 'prop-types';

// Design System
import Typography from '@material-ui/core/Typography';

function TabLabel(props) {
  const { label, variant, ...rest } = props;

  return (
    <Typography color='textPrimary' variant={variant} {...rest}>
      {label}
    </Typography>
  );
}

TabLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default TabLabel;
